import { Box } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useState } from "react";
import { UpgradeDialogSource } from "schemas/dashboard";

import StyledBanner from "components/Styled/Banner";
import ReferralDialogNavigation from "features/Home/ReferralDialog/navigation";
import { REFERRAL_CREDIT } from "utils/influencer";
import { trackEvent } from "utils/tracking";

const SpecialAnnouncementCard = () => {
  const { subscription, setUpgradeDialogSource } =
    useContext(SubscriptionContext);
  const [navigationReferDialog, setNavigationReferDialog] = useState(false);

  const isAnnualPlan = subscription?.subscription?.planName?.includes("yearly");

  if (!isAnnualPlan) {
    return (
      <StyledBanner
        chip={
          <>
            <Box
              component="i"
              className="fa-solid fa-star"
              sx={{ color: "purple.dark", mr: 0.5 }}
            />{" "}
            For Serious Creators
          </>
        }
        snippet="🔒 Lock in Bento's Current Pricing for a Full Year"
        title=""
        description="Secure today's rates before prices increase. Save over 25% and guarantee your annual pricing."
        buttonText="Subscribe to Annual Plan"
        handleClick={() => {
          setUpgradeDialogSource(UpgradeDialogSource.annual_plan_home_page);
        }}
      />
    );
  } else {
    return (
      <>
        <StyledBanner
          snippet="🥳 Invite Friends, Get Rewarded"
          title=""
          description={
            <>
              {" "}
              Give ${REFERRAL_CREDIT} to a new user. Get ${REFERRAL_CREDIT} when
              they subscribe. Credits will be auto-applied towards your next
              invoice.
            </>
          }
          buttonText="Start Referring"
          handleClick={() => {
            trackEvent("Referral Promo Button Clicked");
            setNavigationReferDialog(true);
          }}
        />
        <ReferralDialogNavigation
          open={navigationReferDialog}
          close={() => setNavigationReferDialog(false)}
          source="Referral Promo Button Clicked"
        />
      </>
    );
  }
};

export default SpecialAnnouncementCard;
